/**
 * * Элемент списка админов проекта
 */
export default class UpsertProjectAdminListRequestItem  {
	/**
	 * * Номер пользователя
	 */
	UserId!: number;
	/**
	 * * Флаг для установки доступа на изменение очередности задач своей команде в пределах проекта
	 */
	CanCustomizeOrder: boolean = false;
	constructor(obj?: Partial<UpsertProjectAdminListRequestItem>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
